import { PHASES } from "const/phases.const";

export const header = {
  data: {
    logo: {
      desktop: "/assets/images/nip-header-logo.svg",
      mobile: "/assets/images/nip-header-logo-mobile.svg",
    },
    icons: [
      {
        image: "/assets/icons/icon-discord.svg",
        link: "https://discord.gg/highsnobiety",
      },
      {
        image: "/assets/icons/icon-twitter.svg",
        link: "https://twitter.com/highsnobiety",
      },
      {
        image: "/assets/icons/icon-opensea.svg",
        link: "https://opensea.io/collection/not-in-paris",
      },
    ],
    buttons: [ 
      {
        phase: [PHASES.PREMINT],
        label: "apply for allowlist",
        link: "https://www.premint.xyz/not-in-paris/",
      },
      {
        phase: [PHASES.WAITING],
        label: "Check Allowlist",
        link: "https://www.premint.xyz/not-in-paris/verify/",
      },
      {
        phase: [PHASES.MINT],
        label: "mint here",
        link: "https://nft.highsnobiety.com/notinparis/mint",
      },
      {
        phase: [PHASES.POST, PHASES.AIRDROP],
        label: "sold out",
        link: "#",
        disabled: true,
      },
    ],
  },
};
